<script lang="ts">
    import { Encounter } from "./encounters";
    import { Danger, GroupLevel } from "./types";
    import { currentEncounterParams, currentEncounters } from "./store";
    import { showEncounters } from "./ui.store";
    let playerCount = $currentEncounterParams.playerCount;
    let groupLevel = $currentEncounterParams.groupLevel;
    let danger = $currentEncounterParams.danger;

    function generateEncounters() {
        let newEncounters = {};
        Object.keys(Danger).forEach(
            (danger) =>
                (newEncounters[danger] = new Encounter({
                    ...$currentEncounterParams,
                    danger: Danger[danger],
                }))
        );
        currentEncounters.set(newEncounters);
        showEncounters();
    }

    $: currentEncounterParams.set({ playerCount, groupLevel, danger });
</script>

<div>
    <h2>PARAMETERS</h2>
    <label>
        Player Count
        <input type="number" bind:value={playerCount} min="1" max="10" />
    </label>
    <label>
        Group Level
        <select bind:value={groupLevel}>
            {#each Object.keys(GroupLevel) as groupLevel}
                <option value={groupLevel}>{groupLevel}</option>
            {/each}
        </select>
    </label>
    <button on:click={generateEncounters}>Generate</button>
</div>
